/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pg_Signup_EmailInputs */



/**
* | output |
* | --- |
* | "### Email Enter your email address and tap the button below. You'll receive a magic link — click it to finish creating your account and set a password." |
*
* @param {Pg_Signup_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const pg_signup_email = /** @type {((inputs?: Pg_Signup_EmailInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pg_Signup_EmailInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("### Email\n\nEntrez votre adresse email et appuyez sur le bouton ci-dessous. Vous recevrez un lien magique — cliquez dessus pour terminer la création de votre compte et définir un mot de passe.")
	if (locale === "es") return /** @type {LocalizedString} */ ("### Correo electrónico\n\nIngrese su dirección de correo electrónico y pulse el botón de abajo. Recibirá un enlace mágico — haga clic en él para terminar de crear su cuenta y establecer una contraseña.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("### E-mail\n\nInsira seu endereço de e-mail e toque no botão abaixo. Você receberá um link mágico — clique nele para concluir a criação da conta e definir uma senha.")
	if (locale === "it") return /** @type {LocalizedString} */ ("### Email\n\nInserisci il tuo indirizzo email e premi il pulsante in basso. Riceverai un magic link — cliccalo per completare la creazione dell'account e impostare una password.")
	return /** @type {LocalizedString} */ ("### Email\n\nEnter your email address and tap the button below. You'll receive a magic link — click it to finish creating your account and set a password.")
});